import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoVinculos = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tipoVinculos`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_VINCULOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoVinculos;
